import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./ui/App";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-boost";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";

const httpLink = createHttpLink({
  uri: "/.netlify/functions/graphql"
  // uri: "http://localhost:9000/graphql"
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  // return the headers to the context so httpLink can read them

  try {
    const user = localStorage.getItem("currentUser") || {};

    const { email, firstName, lastName, id, token } = JSON.parse(user);

    return {
      headers: {
        ...headers,
        authorization: token,
        user: {
          firstName: encodeURI(user.firstName),
          lastName: encodeURI(user.lastName),
          email: encodeURI(user.email)
        }
      }
    };
  } catch (err) {
    console.log({ err });

    return {
      headers: {
        ...headers,
        authorization: "ko",
        user: {}
      }
    };
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({ addTypename: true })
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root")
);
